import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { createContext } from 'use-context-selector';
import toast from 'react-hot-toast';
import { api } from 'core/services/api';

export const QuestionContext = createContext();

export const QuestionProvider = ({ children }) => {

  const [question, setQuestion] = useState({ options: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAnswer, setIsLoadingAnswer] = useState(false);

  const getQuestionById = useCallback(async (id) => {
    setIsLoading(true);
    const result = await api.get("/question/read/" + id)
    if (result.data.success) {
      setQuestion(result.data.content)
    } else {
      result.data.errors.map(toast.error)
    }
    setIsLoading(false);
    return result.data.success;
  }, [])
  
  const answerQuestion = useCallback(async (question, answer) => {
    setIsLoadingAnswer(true);
    const result = await api.post("/answer/create", {
      question,
      answer
    })
    setIsLoadingAnswer(false);
    if (!result.data.success) {
      throw result.data.error
    }
  }, [])

  return (
    <QuestionContext.Provider
      value={{
        question,
        isLoading,
        isLoadingAnswer,
        getQuestionById,
        answerQuestion
      }}
    >
      {children}
    </QuestionContext.Provider>
  );
};

QuestionProvider.propTypes = {
  children: PropTypes.element.isRequired,
};